module.exports = __webpack_public_path__ + "fonts/iconfont.d9d443a0.eot";